import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { selectCurrentCustomerSelected } from '@ruby/modules/customer-select/store/selectors/customers.selectors';
import * as fromReservations from '@ruby/modules/reservations/store/reducers/reservations.reducer';
import { selectRouteParam } from '@ruby/store/selectors/root.selectors';

export const selectReservationsState =
  createFeatureSelector<fromReservations.State>(fromReservations.featureKey);

export const selectReservationsWithStatus = createSelector(
  selectReservationsState,
  selectCurrentCustomerSelected,
  selectRouteParam('status'),
  (state: fromReservations.State, customerSelected?: ICustomer, status?: string) => ({
    state,
    customerSelected,
    status
  })
);
